import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RomeKendoModule, RomeLibraryModule } from 'rome-library';
import { GdprDialogComponent } from './components/gdpr-dialog/gdpr-dialog.component';

@NgModule({
  declarations: [GdprDialogComponent],
  imports: [CommonModule, RomeLibraryModule, RomeKendoModule],
  exports: [GdprDialogComponent]
})
export class GdprDialogModule {}
